import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createI18n, I18nProvider, useI18n } from 'react-simple-i18n';
import { langData } from './locale';
import { routes } from './router';
import { Language } from './model/language';
import './css/fonts.css';
import './css/index.css';
import './css/main.css';
import './css/animations.css';
import './css/components.css';

const browserRouter = createBrowserRouter(routes);

const root = document.getElementById('root') as HTMLElement;

const language =
	(localStorage.getItem('language') as Language) || Language.enUK;

ReactDOM.createRoot(root).render(
	<I18nProvider i18n={createI18n(langData, { lang: language })}>
		<React.StrictMode>
			<RouterProvider router={browserRouter} />
		</React.StrictMode>
	</I18nProvider>,
);
